export let super_config = [
	{
        elements: [
            {
				elementGetParamMap: 'test_multi_filter_select',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: [],
				element_model_default: [],
				label: 'Выбрать канал',
				placeholder: 'Выбрать канал',
				filterable: true,
				multiple: true,
				options:[
					{value: '1', label: 'Канал 1',},
					{value: '2', label: 'Канал 2',},
					{value: '3', label: 'МКанал 3',},
				]
            },
            {
				elementGetParamMap: 'vm_fst|vm_snd|vm_trd',
				elementType: 'checkbox-group',
				element_model: {vm_fst:false,vm_snd:false,vm_trd:true},
				element_model_default: {vm_fst:false,vm_snd:false,vm_trd:true},
				label: '',
				options:[
					{key:'vm_fst',label:'Избранное'},
					{key:'vm_snd',label:'Черновик'},
					{key:'vm_trd',label:'Мои каналы'},
				]
			},
			{
				elementGetParamMap: 'sts|ste',
				elementType: 'input-time-range',
				element_model: {startDt:'',endDt:''},
				element_model_default: {startDt:'',endDt:''},
				label: 'По дате публикации',
				range_separator: '-',
				start_placeholder: 'Время с',
				end_placeholder: 'Время по',
			},
        ]

    }
]